'use client'

import { useEffect, useRef } from 'react'
import { WidgetIframeProps } from '@/types/cms'
import styles from '../Default/iFrameDefault.module.scss'
import SectionTitle from '@/components/SectionTitle/SectionTitle'

const IFrameInfront = ({ item }: { item: WidgetIframeProps }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const rOriginVwd = /^https?:\/\/kursdaten.n-tv.de(\/|:|$)/
    window.addEventListener('message', function (e) {
      if (e.origin.match(rOriginVwd) && typeof e.data == 'string') {
        const message = e.data.split('|')
        if (message[0] === 'vwd.resize') {
          if (iframeRef.current) {
            iframeRef.current.style.height = message[1] + 'px'
          }
        }
      }
    })

    if (iframeRef.current) {
      iframeRef.current.src = item.model.fields.uri
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section>
      <SectionTitle link={item.model?.fields?.link as any} title={item.model.fields.headline ?? ''} />
      <iframe
        ref={iframeRef}
        src={item.model.fields.uri}
        className={styles.infront}
        title="Böresenkurse"
        scrolling="no"
      />
    </section>
  )
}

export default IFrameInfront
